"use strict";

exports.__esModule = true;
var Constants = {};

exports["default"] = Constants;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants.js
 ** module id = 55
 ** module chunks = 2
 **/